var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"saturation",on:{"mousedown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.selectSaturation.apply(null, arguments)}}},[_c('canvas',{ref:"canvasSaturation"}),_c('div',{staticClass:"slide",style:(_vm.slideSaturationStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }